import styled from 'styled-components';

export const ReducedPaddingCard = styled.div(
  ({ theme: { space, mediaQueries } }) => `
    ${mediaQueries.smallAndUp} {
        padding: ${space[6]};
    }
`,
);
